<!-- 图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="info-block">
  <router-link :to="'/jrkjfw/zzjsDetail/'+info.id" v-bind:style="{backgroundImage:'url('+info.img_path+')'}" target="_blank">
    <div class="div-1">
      <div class="div-1-1">免费</div>
    </div>
    <div class="div-2">
      <div class="div-2-1">{{info.title}}</div>
      <div class="div-2-2">{{info.description.length>labelLength?(info.description.substring(0,labelLength)+'...'):info.description}}</div>
      <div class="div-2-3">{{info.create_time}}</div>
    </div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'InfoBlock05',
  props: {
    labelLength:{
      type:Number,
      default:38
    },
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      celWidth: "calc(100%/" + this.col + ")",
    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block a{
  display: block;
  height:300px;
  position:relative;
  box-sizing: border-box;
  padding:0px;
  margin:10px;
  background-color: #fff;
  border:1px solid #eee;
  background-size: 100% 150px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  box-shadow: #bbb 0px 0px 10px;
}

.info-block a:hover{
  border:1px solid orange;
  box-shadow: var(--color6) 0px 0px 5px;
}
.div-1{
  position:relative;
  height:50%;
  //background:green;
}

.div-1-1{
  position: absolute;
  left: -1px;
  top: -1px;
  padding:2px 4px 2px 4px;
  color:#fff;
  background:var(--color6);
  border-radius:0px 0px 8px;
}

.div-2{
  position:relative;
  height:50%;
  //background:blue;
}

.div-2-1{
  position:relative;
  height:30%;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#000;
  padding:10px;
}

.div-2-2{
  position:relative;
  height:50%;
  //background:yellow;
  text-align:left;
  line-height:20px;
  color:#888;
  padding:4px 10px 4px 10px;
}

.div-2-3{
  position:relative;
  height:20%;
  //background:blue;
  text-align:left;
  color:#888;
  padding:4px 10px 4px 10px;
}

.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock05.vue